export default "__VITE_ASSET__d6c0b1bd__"